import { c as _c } from "react/compiler-runtime";
import MUIStack, { StackProps as MUIStackProps } from '@mui/material/Stack';
export interface Props extends MUIStackProps {}
const Stack = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MUIStack {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default Stack;